<p8-layout-settings-page>
  <mat-card>
    <mat-card-title *ngIf="displayTitle">
      <p8-layout-settings-header *ngIf="loaning"
                                 [titlePath]="['Consultation d\'une demande de consultation d\'archive']"
                                 [iconRacine]="'source'"></p8-layout-settings-header>
    </mat-card-title>
    <mat-card-content fxLayout="column">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"
                     [(selectedIndex)]="selectedTabIndex" dynamicHeight>
        <mat-tab label="Demande de consultation">
          <mat-accordion multi *ngIf="loaning">
            <div fxLayout="row"
                 fxLayoutAlign="end center"
                 fxLayoutGap="10px" style="padding-top: 10px;">
              <button mat-raised-button color="accent" *ngIf="showExportZipBtn()"
                      (click)="exportZipScansConsultation()"
                      [matTooltip]="'Télécharger les scans'">
                Télécharger les scans ({{loaning.scans_obj.length}})
              </button>
              <app-loaning-state-chip
                [loaning]="loaning"
                [align]="'end'">
              </app-loaning-state-chip>
            </div>

            <mat-expansion-panel *ngIf="canManage() && loaning?.status && loaning?.status !== loaningState.DRAFT"
                                 class="elt__expansion-panel"
                                 expanded="true">
              <mat-expansion-panel-header class="elt__expansion-panel-header">
                <mat-panel-title class="elt__panel-title">Prise en charge</mat-panel-title>
              </mat-expansion-panel-header>
              <app-take-charge-consultation [loaning]="loaning"></app-take-charge-consultation>
            </mat-expansion-panel>
            <!-- le demandeur  -->
            <mat-expansion-panel class="elt__expansion-panel">
              <mat-expansion-panel-header class="elt__expansion-panel-header">
                <mat-panel-title class="elt__panel-title">
                  Informations du demandeur
                </mat-panel-title>
                <mat-panel-description class="elt__panel-description">
                  {{userInfoLong()}}
                </mat-panel-description>
              </mat-expansion-panel-header>

              <mat-card>
                <mat-card-content>
                  <div fxLayout="column">
                    <mat-list role="list" fxLayout="row" fxFlex>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Intitulé du service ou composante</span>
                          <span class="ctt">{{loaning?.dir_cmp_obj?.entite_archivage_obj?.entite_obj?.name}}</span>
                        </div>
                      </mat-list-item>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Service / Pôle / Département / Labo</span>
                          <span class="ctt">{{loaning?.svc || '-'}}</span>
                        </div>
                      </mat-list-item>
                    </mat-list>

                    <mat-list role="list" fxLayout="row" fxFlex>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Demandeur</span>
                          <span class="ctt">{{userInfo()}}</span>
                        </div>
                      </mat-list-item>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Courriel</span>
                          <span class="ctt">{{loaning?.borrower_obj?.email_pro}}</span>
                        </div>
                      </mat-list-item>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Bureau</span>
                          <span class="ctt">{{loaning?.office}}</span>
                        </div>
                      </mat-list-item>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Téléphone</span>
                          <span class="ctt">{{loaning?.phone_number}}</span>
                        </div>
                      </mat-list-item>
                    </mat-list>
                  </div>
                </mat-card-content>
              </mat-card>
            </mat-expansion-panel>
            <!-- la demande -->
            <mat-expansion-panel class="elt__expansion-panel">
              <mat-expansion-panel-header class="elt__expansion-panel-header">
                <mat-panel-title class="elt__panel-title">
                  La demande
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-card>
                <mat-card-content>
                  <div fxLayout="column">
                    <mat-list role="list" fxLayout="row" fxFlex>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">De l'année </span>
                          <span class="ctt">{{loaning?.year_min || ''}}</span>
                        </div>
                      </mat-list-item>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">A l'année </span>
                          <span class="ctt">{{loaning?.year_max || '-'}}</span>
                        </div>
                      </mat-list-item>
                    </mat-list>
                    <mat-list role="list" fxLayout="row" fxFlex>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Typologie </span>
                          <span class="ctt">{{loaning?.typologie || ''}}</span>
                        </div>
                      </mat-list-item>
                    </mat-list>
                    <mat-list><mat-list-item></mat-list-item></mat-list>
                    <mat-list role="list" class="list-expendable">
                      <mat-list-item role="listitem">
                          <div mat-line class="lbl">Détail </div>
                          <div mat-line class="ctt" [innerHTML]="loaning?.details || '-' |newline"></div>
                      </mat-list-item>
                    </mat-list>
                    <mat-list><mat-list-item></mat-list-item></mat-list>
                  </div>
                </mat-card-content>
              </mat-card>
            </mat-expansion-panel>
          </mat-accordion>
        </mat-tab>
        <mat-tab label="Dialogues" *ngIf="loaning">
          <app-dialogues [Loaning]="loaning" [emails]="emails"></app-dialogues>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
  <p8-layout-settings-footer *ngIf="returnList"
                             [flexLayoutAlign]="'end'">
    <button mat-raised-button type="button"
            matTooltip="Retour à votre liste"
            (click)="goBack()">
      Retour à votre liste
    </button>
  </p8-layout-settings-footer>
</p8-layout-settings-page>
